import { render, staticRenderFns } from "./MatchFeed.vue?vue&type=template&id=1368acec&scoped=true"
import script from "./MatchFeed.vue?vue&type=script&lang=js"
export * from "./MatchFeed.vue?vue&type=script&lang=js"
import style0 from "./MatchFeed.vue?vue&type=style&index=0&id=1368acec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368acec",
  null
  
)

export default component.exports